module.exports = __webpack_public_path__ + "static/MEO_Logo_Sve-ff241ca4ab7c9a5cc96ef5b8047f6f63.svg";